import { cn } from '../../lib/utils';

const AppBrandHeader = ({ collapsed }: { collapsed: boolean }) => {
  return (
    <div className="h-24 bg-[#A23231] flex items-center p-2">
      <div className={'bg-white max-h-16 max-w-16 p-1 rounded-lg'}>
        <img
          className={'w-auto'}
          src="/mmd/mmd.png"
          alt="asia-ceramic-corporation"
        />
      </div>
      <span
        className={cn(
          'text-center p-1 text-white font-semibold text-lg',
          collapsed ? 'hidden' : '',
        )}
      >
        Asia Ceramic Corporation
      </span>
    </div>
  );
};

export default AppBrandHeader;
